var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_vm._v(" 手术管理 "+_vm._s(_vm.entity)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }